import { combineReducers } from 'redux';

import { reducer as form } from 'redux-form';
// reducer import
import authReducer from './authReducer';
import settingsReducer from './settingsReducer';
import wallpaperReducer from './wallpaperReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    form,
    auth: authReducer,
    wallpaper: wallpaperReducer,
    settings: settingsReducer
});

export default reducer;
